import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';

interface DrawFilterBoxParameters {
    onClick: () => void;
    text: string;
    icon?: IconDefinition;
    color: DrawFilterBoxColor;
    count: number;
    isActive: boolean;
}

export enum DrawFilterBoxColor {
    Blue = 'blue',
    Gray = 'gray',
    Green = 'green',
    Orange = 'orange',
    Red = 'red',
    White = 'white',
    Yellow = 'yellow',
}

export const DrawFilterBox: React.FC<DrawFilterBoxParameters> = ({ onClick, text, icon, color, count, isActive }) => {
    let className = `filter-box-${color}`;

    if (!isActive) className += ' box-filter-inactive';

    return (
        <div
            className={className}
            onClick={() => onClick && onClick()}
        >
            <div>{text}</div>
            <div className='filter-box-iconandnumber'>
                {icon && <FontAwesomeIcon icon={icon} />}
                &nbsp;
                <strong>{count.toString()}</strong>
            </div>
        </div>
    );
};
